import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IUser } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class AuthorizationService {
  abstract getUser(): IUser;
  abstract setUser(user: IUser) : void;
  abstract isContractor(user: IUser) : boolean;
  abstract isEngineer(user: IUser) : boolean;
  abstract isHomeowner(user: IUser) : boolean;
  abstract release() : void;
  abstract captureUser() : Observable<IUser>;
}
